import {AxiosResponse} from "axios";
import {$api} from "../api/api.ts";
import {getToken} from "../../utils/Utils.ts";
import {
    CampaignHistoryList,
    IPendingPublicationResponseData,
    ITransferCampaignResponseData,
    IUpdateTransferCampaignParams
} from "../models/TransferCampaignResponse.ts";
import qs from "qs";
import {ICampaignHistoryParams} from "../models/CampaignResponse.ts";

export const transferCampaignService = {
    fetchTransferCampaign(channelId: string): Promise<AxiosResponse<ITransferCampaignResponseData>> {
        return $api.get(`/transfer_campaigns/${channelId}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchPendingPublications(channelId: string): Promise<AxiosResponse<IPendingPublicationResponseData[]>> {
        return $api.get(`/transfer_campaigns/pending/${channelId}`, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    fetchTransferHistory( channelId:string, params?:ICampaignHistoryParams): Promise<AxiosResponse<CampaignHistoryList>> {
        return $api.get(`/transfer_campaigns/history/${channelId}`, {
            params,
            paramsSerializer: params => qs.stringify(params),
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },
    updateTransferCampaign(campaignId: string, params: IUpdateTransferCampaignParams): Promise<AxiosResponse<ITransferCampaignResponseData>> {
        return $api.patch(`/transfer_campaigns/${campaignId}`, params, {
            headers: {
                Authorization: `Bearer tg-${getToken()}`
            }
        })
    },

}